module.exports = __webpack_public_path__ + "media/images/app/testimonials/trending-3-ab1b99758a9672268f3f79e9e0752180.webp";